// extracted by mini-css-extract-plugin
export default {"boxWrapper":"Whiskerplot_boxWrapper__xb4Ab","text":"Whiskerplot_text__cHikf"};